document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.custom-faq-section').forEach(function(section){

        section.querySelectorAll('.faq-question').forEach(function(button){

            button.addEventListener('click', function(){

                const item = this.parentElement;

                item.classList.toggle('active');

            });

        });

    });

});